export default {
  __sunday: '星期日',
  __monday: '星期一',
  __tuesday: '星期二',
  __wednesday: '星期三',
  __thursday: '星期四',
  __friday: '星期五',
  __saturday: '星期六'
}
